export default "__VITE_ASSET__DOQYglTS__"